import React from 'react';
import styles from './A_Day.module.css';
import cn from 'classnames';
import A_DaySelectedImage from '@/assets/images/A_DaySelected.png';

interface A_DayProps {
  day: number | string;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  'aria-label'?: string;
}

export default function A_Day({
  day,
  selected = false,
  disabled = false,
  onClick,
  className = '',
  'aria-label': ariaLabel,
}: A_DayProps) {
  return (
    <button
      type='button'
      className={cn(styles.wrapper, className, {
        [styles.selected]: selected,
        [styles.disabled]: disabled,
      })}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      aria-label={ariaLabel ?? `День ${day}`}
    >
      {selected && (
        <img
          src={A_DaySelectedImage}
          alt='Selected'
          className={styles.selected_image}
        />
      )}
      <span className={cn(styles.label, 'text-p-7')}>{day}</span>
    </button>
  );
}
